"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file */

/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  addAddressFeedback: 'Added!',
  addNewTelephone: 'Add new telephone number',
  addPhoneNumber: 'Add phone number',
  additionalPhones: 'Additional phones',
  cancel: 'Cancel',
  confirmTelephoneDelete: 'Do you really want to delete this telephone?',
  delete: 'Delete',
  deleteTelephone: 'Delete phone number',
  deletedFeedback: 'Deleted',
  edit: 'Edit',
  editAddressFeedback: 'Success!',
  editNumber: 'Edit telephone number',
  editPhoneNumber: 'Edit phone number',
  enterActivePhone: 'Enter your active mobile number',
  errorOccured: 'An error occurred',
  labelWithPrefix: 'Mobile phone',
  needPhoneVerification: 'You need to verify your telephone number',
  newNumber: 'New number',
  noCode: 'Did not get code?',
  phoneHelperText: 'A code will be sent to this phone',
  phoneIsAlreadyVerify: 'Telephone number for the given customer is already verified.',
  phonePlaceholder: 'XXXXXXXXX',
  phonePlaceholderWithPrefix: 'Write your phone in the format XXXXXXXXX',
  primaryTelephoneNumber: 'Is primary telephone number',
  resend: 'Resend',
  resendInMinute: 'Resend code in 1 minute',
  save: 'Save',
  savedSuccessfully: 'Saved successfully',
  showLess: 'Show less',
  showMore: 'Show more',
  telephoneTitle: 'Telephone',
  telephoneVerificationSent: 'We have sent a verification code to phone number {telephoneNumber}, please enter the code below:',
  thisIsMyWhatsAppNumber: 'This is my WhatsApp number',
  tooltipPhone: 'Enter your phone number with international prefix',
  tooltipPrefixPhone: 'Enter your phone number without international prefix',
  unverifiedTelephoneNumber: 'Unverified number',
  useAsPrimaryTelephone: 'Use as primary telephone number',
  validationLength: 'Invalid property length',
  validationRegex: 'This field value does not match requested conditions',
  validationRequired: 'This field is required',
  validationUniquePhone: 'Phone is already used',
  validationValidConfirmationCode: 'Confirmation code is not valid',
  validationValidPhone: 'Phone is not valid',
  verifiedFeedback: 'Verified',
  verifiedPhone: 'You need to',
  verifiedPhoneLink: 'verify this phone',
  verifiedTelephoneNumber: 'Verified number',
  verify: 'Verify',
  verifyPhone: 'Verify phone',
  warning: 'Warning'
};
const translationsNamespace = exports.translationsNamespace = 'phone-manager';
//# sourceMappingURL=defaultTranslations.js.map